<template>
    <div class="page-main">
        <div class="search-bar">
            <div class="left-bar">
                <Button :type="filters.timeSolt===1?'primary':'default'" v-on:click="changeTimeSolt(1)">近一周</Button>
                <Button :type="filters.timeSolt===2?'primary':'default'" v-on:click="changeTimeSolt(2)">近一月</Button>
                <Button :type="filters.timeSolt===3?'primary':'default'" v-on:click="changeTimeSolt(3)">近一年</Button>
            </div>
            <div class="right-bar">
                <div class="right-mian_active">
                    <input placeholder="请输入资源名称" class="input-cla" v-model="filters.keyWord" v-on:keyup.enter="handleSearch"/>
                    <div class="search-btn" v-on:click="handleSearch">
                        <div class="search-icon">
                            <img src="../../../../assets/images/databoard/detailPage/search.png" width="100%"
                                 height="100%"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-main-wrap">
            <div class="table-main">
                <div class="table-content">
                    <div class="header">
                        <Col :span="2">
                        <span>序号</span>
                        </Col>
                        <Col :span="4">
                        <span>学校名称</span>
                        </Col>
                        <Col :span="4">
                        <span>资源名称</span>
                        </Col>
                        <Col :span="4">
                        <span>上传人</span>
                        </Col>
                        <Col :span="5">
                        <span>上传时间</span>
                        </Col>
                        <Col :span="5">
                        <span>资源大小</span>
                        </Col>
                    </div>
                    <div class="row-wrap">
                        <template v-for="(item,index) in resourceList" v-if="resourceList.length>0">
                            <Row :gutter="12" :class="index % 2 === 0 ? 'row-single':'row-double'">
                                <Col :span="2" class="col-content">
                                <span>{{item.rowNum}}</span>
                                </Col>
                                <Col :span="4" class="col-content">
                                <span>{{item.schoolName ==='' ? '暂无':item.schoolName}}</span>
                                </Col>
                                <Col :span="4" class="col-content">
                                <template v-if="item.title===''">
                                <span :title="item.title">暂无</span>
                                </template>
                                <template v-else>
                                    <a :title="item.title" href="javascript:void(0);" v-on:click="openPreview(item.resultUrl,item.count,item.fileType,index)" style="color: #2d8cf0;">{{item.title}}</a>
                                </template>
                                </Col>
                                <Col :span="4" class="col-content">
                                <span>{{item.userRealName ==='' ? '暂无':item.userRealName}}</span>
                                </Col>
                                <Col :span="5" class="col-content">
                                <span>{{item.createTime ==='' ? '暂无':item.createTime}}</span>
                                </Col>
                                <Col :span="5" class="col-content">
                                <span>{{$utils.bytesToSize(item.fileSize)}}</span>
                                </Col>
                            </Row>
                        </template>
                        <template v-if="resourceList.length===0">
                            <Row :gutter="12" class="row-single">
                                <Col :span="24">
                                <span>暂无数据</span>
                                </Col>
                            </Row>
                        </template>
                    </div>
                </div>
            </div>
            <div class="bottom-page">
                <div class="laypage_main">
                    <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                          v-if="pageParams.total && pageParams.pageCount>1"></Page>
                </div>
            </div>
        </div>
        <!-- 预览轮播 -->
        <!--<preview-slider-->
            <!--ref="previewSlider"-->
            <!--:previewMode="previewMode"-->
            <!--:previewVideoMode="previewVideoMode"-->
            <!--:videoSrc="videoSrc"-->
            <!--@closePreview="closePreview"-->
        <!--&gt;</preview-slider>-->

        <dt-preview-slider
                ref="previewSlider"
                :previewMode="previewMode"
                :previewVideoMode="previewVideoMode"
                :videoSrc="videoSrc"
                @closePreview="closePreview"
        ></dt-preview-slider>
    </div>
</template>

<script>
    import {findResourceList} from "../../../../service/api.js";

    // const previewSlider = () => import("./previewSlider");
    export default {
        name: "resource-list",
        // components: {
        //     previewSlider
        // },
        data () {
            return {
                resourceList: [],
                filters: {
                    schoolId: this.$route.params.schoolId == 0 ? '' : this.$route.params.schoolId,
                    timeSolt: 0,
                    keyWord: '',
                    startDate: '',
                    endDate: ''
                },
                pageParams: {
                    page: 1,
                    limit: 10,
                    total: 0,
                    pageCount: 0
                },
                previewMode: false,
                previewVideoMode: false,
                videoSrc: ""
            }
        },
        created () {
            let currentPathArr;
            currentPathArr = [
                {
                    title: "首页",
                    path: "databoard",
                    name: "databoard",
                    params: {
                        schoolCode: this.$route.params.schoolCode,
                    }
                },
                {
                    title: this.$route.params.schoolName,
                    path: "",
                    name: "schoolName"
                },
                {
                    title: "全部资源",
                    path: "",
                    name: "resourceList"
                }
            ];
            this.$store.commit("setCurrentPath", currentPathArr);
        },
        methods: {
            /**
             * 获取资源列表
             */
            async getResourceList () {
                let _this = this;
                let params = {
                    schoolId: _this.filters.schoolId,
                    keyWord: _this.filters.keyWord,
                    startDate:_this.filters.startDate,
                    endDate:_this.filters.endDate,
                    page: _this.pageParams.page,
                    limit: _this.pageParams.limit
                };
                let resultData = await findResourceList(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.resourceList = resultData.rows;
                _this.pageParams.total = resultData.total_rows;
                _this.pageParams.pageCount = resultData.page_count;
            },
            /**
             * 翻页
             */
            handleCurrentChange (val) {
                this.pageParams.page = val;
                this.getResourceList();
            },
            /**
             * 查询
             */
            handleSearch () {
                this.pageParams.total = 0;
                this.pageParams.page = 1;
                this.pageParams.pageCount = 0;
                this.getResourceList();
            },
            /**
             * 选择时间段
             */
            changeTimeSolt (type) {
                //反选的情况
                if (this.filters.timeSolt === type) {
                    this.filters.timeSolt = 0;
                    this.filters.startDate='';
                    this.filters.endDate='';
                } else {
                    this.filters.timeSolt = type;
                }
                //获取近一周时间
                if (this.filters.timeSolt === 1) {
                    this.filters.startDate = this.$utils.getWeekStartDate() + ' 00:00:00';
                    this.filters.endDate = this.$utils.getWeekEndDate() + ' 23:59:59';
                } else if (this.filters.timeSolt === 2) {
                    //获取近一月时间
                    this.filters.startDate = this.$utils.getMonthStartDate() + ' 00:00:00';
                    this.filters.endDate = this.$utils.getMonthEndDate() + ' 23:59:59';
                } else if (this.filters.timeSolt === 3) {
                    //获取近一年时间
                    this.filters.startDate = this.$utils.getYearStartDate() + ' 00:00:00';
                    this.filters.endDate = this.$utils.getYearEndDate() + ' 23:59:59';
                }
                this.handleSearch();
            },
            /**
             * 预览资源
             */
            openPreview(resultUrl, count, type, index) {
                // type 0:其他 1.文档 2.视频 3.音频 4.图片
                if (type === 2 || type === 5) {
                    this.previewVideoMode = true;
                    this.videoSrc = resultUrl + "/video.mp4";
                    return;
                } else if (type === 3) {
                    this.$set(this.resourceList[index], "isPlaying", 1);
                    return;
                }
                if (!count) {
                    this.$Message.error("暂无缩略图，无法预览！");
                    return;
                }
                this.previewMode = true;
                this.$refs.previewSlider.swiperInit(resultUrl, count);
            },
            // 关闭预览
            closePreview(type) {
                this[type] = false;
            }
        },
        mounted () {
            this.getResourceList();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../style/detailPage";
</style>
